<app-modal-dialog #modal title="{{ (selectedTag.id == '' ? 'dietaryTags.create' : 'dietaryTags.edit') | translate }}"
    [modalId]="modalId" okText="{{ 'dietaryTags.save' | translate }}" [isValid]="name.invalid == false"
    (onClose)="modalClosed($event)">
    <div class="form-col">
        <input [(ngModel)]="selectedTag.title" required #name="ngModel" type="text" class="ihost-control w-100 mb-2"
            placeholder="{{ 'dietaryTags.placeholders.tag' | translate }}" />
    </div>
</app-modal-dialog>